import { useTheme } from '../useTheme';
import { ColorMode } from './interfaces';

export function useColors(): ColorMode {
  const theme = useTheme();
  return theme.colors[theme.mode];
}
